import "../css/PopWishWindows.css";

export default function PopWishWindows({
    showState,
    currentItem,
    nextItem,
    onConfirm,
    onCancel,
    getColor,
    title,
    description,
}) {
    if (!showState || !currentItem || !nextItem) {
        return null;
    }

    return (
        <div className="pop-windows">
            <div className="pop-windows-container">
                <div className="pop-windows-container-text">{title}</div>
                <div className="pop-windows-container-description">{description}</div>
                <div className="pop-windows-current">
                    <div className="pop-windows-item-title">当前目标</div>
                    <div className="pop-windows-container-name" style={{ color: getColor(currentItem.star) }}>
                        {currentItem.name}
                    </div>
                    <div className="image-box">
                        <img src={currentItem.image} className="showWishPicture" alt={currentItem.name} />
                    </div>
                </div>
                <div className="pop-windows-next">
                    <div className="pop-windows-item-title">新目标</div>
                    <div className="pop-windows-container-name" style={{ color: getColor(nextItem.star) }}>
                        {nextItem.name}
                    </div>
                </div>
                <div className="pop-button-row">
                    <button onClick={onConfirm}>确认重新定轨</button>
                    <button onClick={onCancel}>返回</button>
                </div>
            </div>
        </div>
    );
}
